import { useNavigate, useParams } from "react-router-dom";
import { trashOutline } from "../../asset";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import useConfirmToast from "../../util/hooks/useConfirmToast";
import ProfileData from "./ProfileData";
import { useEffect, useState } from "react";
import QueryApis from "../../api/QueryApis";
import { QueryItem } from "../../types/Query";
import SubButton from "../../components/SubButtons";

export default function ViewQueryDetails() {
  const { confirm, modal } = useConfirmToast();
  const { id } = useParams<{ id: string }>();
  const queryId = Number(id);
  const navigate = useNavigate()

  const [data, setData] = useState<QueryItem | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!queryId) return;

    QueryApis.getQueryById(queryId)
      .then((res) => {
        setData(res.data);
      })
      .finally(() => setLoading(false));
  }, [queryId]);

  const handleDelete = async (id: number) => {
    const confirmed = await confirm(
      "Are you sure you want to remove this query?",
    );

    if (!confirmed) return;

    const response = await QueryApis.deleteQuery(id);

    if (response) {
      
      navigate("/queries");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!data) return <div>Query not found</div>;

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col lg:flex-row justify-between  gap-5">
        <PageHeader title={`QUERY DETAILS #${id}`} showBack />
        <div>
          <SubButton
            color="bg-error-600"
            text="Delete"
            icon={trashOutline}
            onClick={() => handleDelete(queryId)}
          />
          {modal}
        </div>
      </div>

      <ProfileData
        data={data}
        onUpdated={(updatedData) => {
          setData(updatedData);
        }}
      />
    </div>
  );
}
